import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Displays the full name of the user's person.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
export const ListItemCellUserLoginname = (classes, props = {}) => {
  const { loginName } = props

  return (
    <Typography
      color={'black'}
      variant={'body2'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {loginName.split(':').pop()}
    </Typography>
  )
}

export default CellHOC(ListItemCellUserLoginname)
